import React, { useState } from 'react';
import { shape } from 'prop-types';
import { Box, Button, Collapse, List, ListItem } from '@mui/material';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';

const MobileFilters = ({ children }) => {
  const [collapseOpen, collapseSetOpen] = useState(true);

  const handleCollapseClick = () => {
    collapseSetOpen(!collapseOpen);
  };

  return (
    <List disablePadding>
      <Box
        bgcolor="surface.mobile"
        sx={{
          borderBottom: `1px solid rgba(0, 0, 0, 0.12)`,
          pb: 0,
          pt: collapseOpen ? 3 : 0,
          px: 2,
        }}
      >
        <Collapse in={collapseOpen} timeout="auto" unmountOnExit>
          <ListItem disableGutters sx={{ p: 0 }}>
            {children}
          </ListItem>
        </Collapse>
        <Button
          onClick={handleCollapseClick}
          sx={{
            pb: 1,
            pt: '14px',
            px: 0,
          }}
          variant="text"
        >
          {collapseOpen ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
          {collapseOpen ? 'Collapse Filters' : 'Expand Filters'}
        </Button>
      </Box>
    </List>
  );
};

export default MobileFilters;

MobileFilters.propTypes = {
  children: shape({}).isRequired,
};
